exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buildPortfolio__main{background-color:#ffffff;margin-top:-145px;position:relative;min-height:655px;margin-left:-15px;padding:5px 15px;width:calc(100% + 30px);border-radius:10px 10px 0 0;z-index:1000}.buildPortfolio__main .tab-content{padding-top:20px}.buildPortfolio__main .tab-content_failed{text-align:center}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/CreataPortfolioByAnalysis.style.scss
// module id = 1660
// module chunks = 0